import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/web.dom-collections.for-each.js";
import React from 'react';
import { matchPath, useLocation } from 'react-router-dom';
import TooltipButton from 'components/TooltipButton';
import useBreakpoints from 'hooks/useBreakpoints';
import useCustomContactLink from 'hooks/useCustomContactLink';
import { DEFAULT_EDIT_PLAYLIST_ROUTES } from 'screens/SinglePlaylistManager';
import { COACH_AI_ROUTE } from 'utils/routes';

/**
 * On pages with other important controls near the bottom edge
 * of the screen, we don't want to render the floating contact button
 */
import { jsx as _jsx } from "react/jsx-runtime";
var PATHS_WITHOUT_FLOATING_BUTTON = [].concat(_toConsumableArray(Object.values(DEFAULT_EDIT_PLAYLIST_ROUTES)), [COACH_AI_ROUTE]);
function FloatingContactButton() {
  var _useCustomContactLink = useCustomContactLink(),
    openModal = _useCustomContactLink.openModal,
    url = _useCustomContactLink.url,
    title = _useCustomContactLink.title;
  var _useLocation = useLocation(),
    pathname = _useLocation.pathname;
  var hideFloatingButton = PATHS_WITHOUT_FLOATING_BUTTON.some(function (path) {
    return matchPath({
      path: path,
      end: false
    }, String(pathname).toLowerCase());
  });
  var _useBreakpoints = useBreakpoints(),
    isDesktop = _useBreakpoints.xl;
  if (!isDesktop && hideFloatingButton) {
    return null;
  }
  var buttonProps = {
    round: true,
    variant: 'important',
    icon: 'chat',
    position: 'fixed',
    bottom: 'm',
    right: 'm',
    z: 'navbars',
    title: title,
    tooltipPlacement: 'top-end'
  };
  if (url) {
    return /*#__PURE__*/_jsx(TooltipButton, _objectSpread(_objectSpread({}, buttonProps), {}, {
      as: "a",
      href: url,
      target: "_blank"
    }));
  } else {
    return /*#__PURE__*/_jsx(TooltipButton, _objectSpread(_objectSpread({}, buttonProps), {}, {
      as: "button",
      onClick: openModal
    }));
  }
}
export default FloatingContactButton;